// LLM generated - Model Claude 4 Sonnet

export default {
  header: {
    title: 'Promotions',
  },
  referral: {
    title: 'Refer friends, get $10!',
    description:
      "When friends join Splash with your referral code, you'll each receive $10 in credits.",
    viewTerms: 'View terms',
    instructions: 'Instructions',
    instruction1: 'Copy or share your referral code and send it to your friends.',
    instruction2: 'Your friends will enter your code when they sign up on Splash.',
    instruction3:
      "After your friend enters their first $10+ contest and it starts, you'll each receive $10.",
    copyCode: 'Copy',
    shareLink: 'Share referral link',
    copySuccess: 'Referral code copied!',
    copyError: 'Failed to copy referral code',
    claimError: 'Invalid referral code',
  },
  myMissions: {
    activeTitle: 'Active',
    completedTitle: 'Completed',
    emptyTitle: 'No other Challenges available',
    emptyDescription: `When you receive Challenges,
    they’ll show up here.`,
  },
  missionDetail: {
    endsIn: 'Ends in {{countdown}}',
    viewTerms: 'View full terms',
    cta: {
      quickpicks: 'Play QuickPicks',
    },
    completedEyebrow: 'Challenge completed',
    completedTitle: 'You unlocked a reward!',
    gotIt: 'Got it!',
  },
  myPromotions: {
    title: 'My Promotions',
    description: 'View and manage your available promotions and vouchers.',
    all: 'All',
    boosts: 'Boosts & No Sweat',
    quickpicks: 'QuickPicks',
    vouchers: 'Vouchers',
    emptyState: {
      title: 'No promotions available',
      description:
        "When you receive promotions, like payout boosts and vouchers, they'll show up here.",
    },
    segmentControl: {
      promotions: 'Promotions',
      challenges: 'Challenges',
    },
    promoCodes: {
      enterAction: 'Enter Promo code',
      promoCodeForm: {
        title: 'Enter Promo code',
        label: 'Promo code',
        applyButton: 'Apply',
        invalidError: 'Invalid promo code format.',
      },
    },
  },
  bonusModal: {
    title__hasPlural: {
      one: "You've unlocked a bonus!",
      other: "You've unlocked {{count}} bonuses!",
    },
    titleAssociated__hasPlural: {
      one: "You've unlocked a bonus by {{user}}!",
      other: "You've unlocked {{count}} bonuses by {{user}}!",
    },
    titleRaf: "You've unlocked a referral bonus!",
    titleDepositBonus: 'Congrats! You unlocked a deposit match!',
    description__hasPlural: {
      one: 'Click Redeem & Continue below to add this promotion to your account.',
      other: 'Click Redeem & Continue below to add these promotions to your account.',
    },
    descriptionAutoApplied__hasPlural: {
      one: 'Your bonus has been unlocked and added to your Promotions centre.',
      other: 'Your bonuses has been unlocked and added to your Promotions centre.',
    },
    descriptionRegistrationPromo:
      'To redeem, complete signup. Eligible bonuses will be added to your Promotions Centre.',
    descriptionReferral:
      'You and your referrer will receive {{amount}} in credits after you enter a {{amount}}+ contest and it starts.',
    descriptionDepositBonus:
      'Your deposit match bonus will automatically activate on your deposit.',
    action: 'Redeem & Continue',
    actionAcknowledge: 'Got it',
    actionAutoApplied: 'Confirm & Continue',
    amountFallback: 'Bonus',
    promoTicket: {
      credit: {
        title1: 'Bonus',
        title2: 'Credit',
        description1: 'Receive a non-withdrawable credit bonus straight to your account!',
      },
      qpBoost: {
        title1: 'QuickPicks',
        title2boost: 'Boost',
        title2noSweat: 'No Sweat',
      },
      voucher: {
        title1: 'Free',
        title2: 'Entry',
        description1: 'Enter {{league}} {{contestType}} contest for free!',
        description2: '{{maxValue}} entry max.',
      },
      deposit: {
        title1: 'Deposit',
        title2: 'Bonus',
      },
      depositMatch: {
        title1: 'Deposit',
        title2: 'Match',
      },
      referral: {
        title1: 'Bonus',
        title2: 'Credit',
        description1:
          'Enter a {{amount}}+ contest and both you and your referrer will receive {{amount}} in credits',
      },
    },
    offerExpires: 'Offer expires:',
  },
  promoCard: {
    actions: {
      applied: 'Applied',
      enter: 'Enter',
      apply: 'Apply',
      remove: 'Remove',
      pick: 'Pick',
      deposit: 'Deposit',
      default: 'Use',
      use: 'Use',
    },
    expiration: {
      expired: 'Expired',
      expires: 'Expires',
      expiresIn: 'Expires in',
      expAbbreviated: 'Exp',
    },
    completion: {
      completedAt: 'Completed',
    }
  },
  modal: {
    promoTerm: {
      title: 'Promotion terms',
    },
  },
  voucherError: {
    title: 'Failed to load vouchers',
    description: "We couldn't load your vouchers. Please try again.",
    retryButton: 'Try Again',
  },
  boostError: {
    title: 'Failed to load boosts',
    description: "We couldn't load your boosts. Please try again.",
    retryButton: 'Try Again',
  },
  depositBonus: {
    title: 'Deposit Bonus',
    emptyState: {
      title: 'No deposit bonuses available',
      description: 'Check back later for deposit bonus offers.',
    },
    error: {
      title: 'Failed to load deposit bonuses',
      description: "We couldn't load your deposit bonuses. Please try again.",
      retryButton: 'Try Again',
    },
  },
};
